import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const KEY = 'rpi_edge_unlocked';

/**
 * R-Pi Edge is a beta feature hidden behind a per-browser password unlock
 * (password "2004" — set in Settings). Persisted in localStorage; a `storage`
 * event listener + a custom `rpi-edge-unlock` window event keep every mounted
 * component in sync (so Sidebar + Machine Master + Diagnostics all update
 * without a page reload the moment the admin flips the switch in Settings).
 */
export function useRpiEdgeUnlock() {
  const { user } = useAuth();
  const [unlocked, setUnlocked] = useState(() => {
    try { return localStorage.getItem(KEY) === 'true'; } catch { return false; }
  });

  useEffect(() => {
    const sync = () => {
      try { setUnlocked(localStorage.getItem(KEY) === 'true'); } catch { setUnlocked(false); }
    };
    window.addEventListener('storage', sync);
    window.addEventListener('rpi-edge-unlock', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('rpi-edge-unlock', sync);
    };
  }, []);

  return unlocked || ((user && user.allowed_modules) || []).includes('event_logs');
}

export function setRpiEdgeUnlock(v) {
  try {
    if (v) localStorage.setItem(KEY, 'true');
    else localStorage.removeItem(KEY);
    window.dispatchEvent(new Event('rpi-edge-unlock'));
  } catch { /* localStorage disabled — ignore */ }
}
